import { rarityTheme } from "./rarityTheme";
import { soulsmithColors, soulsmithMotion, soulsmithStates } from "./visualTokens";

export const combatStateVisuals = {
  movementMarker: {
    desktop: { radius: 1.2, color: soulsmithColors.antiqueGold, secondaryColor: soulsmithColors.bloodRed },
    mobile: { radius: 0.75, color: soulsmithColors.antiqueGold, secondaryColor: soulsmithColors.bloodRed },
    reducedMotion: "single static rune ring"
  },
  enemyHover: {
    normal: { outline: soulsmithColors.bloodRed, width: 1 },
    harvestable: { outline: soulsmithColors.primalWhiteGold, shimmer: true }
  },
  lightAttack: {
    trail: "short weapon-theme trail",
    spark: soulsmithColors.emberOrange,
    cameraImpulse: "minimal"
  },
  heavyAttack: {
    charge: "socket light gathers along weapon",
    groundRune: soulsmithColors.bloodRed,
    impactArc: "large weapon-family arc",
    cameraImpulse: "weight scaled"
  },
  guard: {
    flare: "obsidian shield",
    contactSparks: soulsmithColors.antiqueGold,
    staminaBurn: true
  },
  guardBreak: {
    ui: "red fracture flash",
    sound: "metal snap",
    motion: soulsmithMotion.crackSpread
  }
} as const;

export const momentumVisuals = {
  low: { range: [0, 24], weapon: "dull", bar: soulsmithStates.idle },
  ember: { range: [25, 49], weapon: "ember sparks", bar: soulsmithStates.hover },
  trail: { range: [50, 74], weapon: "visible trail", bar: soulsmithStates.active },
  fracture: { range: [75, 99], weapon: "bright soul cracks", bar: soulsmithStates.danger },
  overdrive: { range: [100, 100], weapon: "molten red/gold", bar: soulsmithStates.mythic }
} as const;

export const woundStateVisuals = {
  pristine: { threshold: 100, posture: "normal", material: "clean silhouette" },
  scarred: { threshold: 75, posture: "guarded", material: "red cracks" },
  broken: { threshold: 50, posture: "limp", material: "damaged mask" },
  dying: { threshold: 25, posture: "berserk or flee", material: "unstable glow" },
  harvestable: { threshold: 0, posture: "kneeling or collapsed", material: "Essence orb" }
} as const;

export const harvestOrbVisuals = {
  common: { ...rarityTheme.common.orb, color: rarityTheme.common.color },
  uncommon: { ...rarityTheme.uncommon.orb, color: rarityTheme.uncommon.color },
  rare: { ...rarityTheme.rare.orb, color: rarityTheme.rare.color },
  legendary: { ...rarityTheme.legendary.orb, color: rarityTheme.legendary.color, vignette: true },
  mythic: { ...rarityTheme.mythic.orb, color: rarityTheme.mythic.color, earthquakePulse: true },
  primal: { ...rarityTheme.primal.orb, color: rarityTheme.primal.color, timeStopMs: 1000 }
} as const;

export const systemStateVisuals = {
  offlineQueued: {
    label: "Memory Not Yet Bound",
    state: soulsmithStates.offline
  },
  reconnectRestored: {
    label: "Soul Memory Restored",
    state: soulsmithStates.selected
  },
  wardenRejected: {
    label: "The Warden rejected this memory.",
    state: soulsmithStates.wardenRejected
  },
  deathFragmented: {
    label: "SOUL FRAGMENTED",
    state: soulsmithStates.danger,
    motion: soulsmithMotion.deathFracture
  }
} as const;
